import { DtLocationWithText } from '@ow/ditto-core'

const { validation, filterSpec } = DtLocationWithText

export { default as Filter } from './filter'
export { validation, filterSpec }
